import {rateCardSvg as Icon__small__rateCardSvg} from '../Icon__small/Icon__small--rateCard.js';
import {rateCardSvg as Icon__xsmall__rateCardSvg} from '../Icon__xsmall/Icon__xsmall--rateCard.js';

export var rateCard = {
  name: 'rateCard',
  category: 'icon',
  colorable: true,
  svg: Icon__small__rateCardSvg,
  alt: {
    Icon__small: Icon__small__rateCardSvg,
    Icon__xsmall: Icon__xsmall__rateCardSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
